<!--
 * @Description: 按钮右侧提示文案组件
 * @Author: mdb
 * @Date: 2023-02-16 09:43:02
 * @LastEditTime: 2023-02-16 09:51:41
 * @LastEditors: mdb
-->
<template>
  <div class="table-button-wrapper">
    <div class="table-button-left">
      <slot />
    </div>
    <div class="table-button-right">
      <info-circle-outlined />
      <span>{{ text }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { InfoCircleOutlined } from '@ant-design/icons-vue'
import type { PropType } from 'vue'

defineProps({
  text: {
    type: String as PropType<string>
  }
})
</script>
<script lang="ts">
export default { name: 'ButtonWrapperTips' }
</script>

<style lang="scss" scoped>
.table-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .table-button-right {
    display: flex;
    align-items: center;
    color: #999;

    .anticon {
      padding-right: 5px;
    }
  }
}
</style>
